export function isJa(locale) {
    return locale === 'ja';
}

export function isEn(locale) {
    return locale === 'en';
}